import { render, staticRenderFns } from "./AdminAgenda.vue?vue&type=template&id=370b5ad4&"
import script from "./AdminAgenda.vue?vue&type=script&lang=js&"
export * from "./AdminAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports